import { NETWORKS_DISABLE_ADD_OPERATIONS } from '@/constants/NETWORK_PARAMS';

export const checkIfNetworkIdDisabledToAdd = (networkId: number | string | undefined): boolean => {
  if (networkId === undefined) {
    return false;
  }
  return NETWORKS_DISABLE_ADD_OPERATIONS.includes(Number(networkId));
};
